"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupType = exports.GroupSortType = exports.CommentNotificationValue = exports.FeedNotificationValue = exports.MutedNotificationValue = exports.GroupPreferenceKey = exports.GroupMemberPermission = void 0;
var GroupMemberPermission;
(function (GroupMemberPermission) {
    GroupMemberPermission[GroupMemberPermission["Admin"] = 0] = "Admin";
    GroupMemberPermission[GroupMemberPermission["Moderator"] = 1] = "Moderator";
    GroupMemberPermission[GroupMemberPermission["NormalUser"] = 2] = "NormalUser";
})(GroupMemberPermission = exports.GroupMemberPermission || (exports.GroupMemberPermission = {}));
var GroupPreferenceKey;
(function (GroupPreferenceKey) {
    GroupPreferenceKey["Visibility"] = "visible";
    GroupPreferenceKey["MemberRequest"] = "memberRequest";
    GroupPreferenceKey["SubChatroom"] = "subChatroom";
    GroupPreferenceKey["InvitationPermission"] = "invitationPermission";
    GroupPreferenceKey["PostFeedPermission"] = "postFeedPermission";
    GroupPreferenceKey["PostCommentPermission"] = "postCommentPermission";
    GroupPreferenceKey["PrivateLinkSharing"] = "privateLinkSharing";
    GroupPreferenceKey["PinFeedPermission"] = "pinFeedPermission";
    GroupPreferenceKey["PinMessagePermission"] = "pinMessagePermission";
    GroupPreferenceKey["MutePermission"] = "mutePermission";
    GroupPreferenceKey["BlacklistPermission"] = "blacklistPermission";
    GroupPreferenceKey["KickPermission"] = "kickPermission";
})(GroupPreferenceKey = exports.GroupPreferenceKey || (exports.GroupPreferenceKey = {}));
var MutedNotificationValue;
(function (MutedNotificationValue) {
    MutedNotificationValue[MutedNotificationValue["NotMuted"] = 0] = "NotMuted";
    MutedNotificationValue[MutedNotificationValue["Muted"] = 1] = "Muted";
})(MutedNotificationValue = exports.MutedNotificationValue || (exports.MutedNotificationValue = {}));
var FeedNotificationValue;
(function (FeedNotificationValue) {
    FeedNotificationValue[FeedNotificationValue["Disabled"] = 0] = "Disabled";
    FeedNotificationValue[FeedNotificationValue["TaggedFeed"] = 1] = "TaggedFeed";
    FeedNotificationValue[FeedNotificationValue["AllFeed"] = 2] = "AllFeed";
})(FeedNotificationValue = exports.FeedNotificationValue || (exports.FeedNotificationValue = {}));
var CommentNotificationValue;
(function (CommentNotificationValue) {
    CommentNotificationValue[CommentNotificationValue["TaggedComment"] = 0] = "TaggedComment";
    CommentNotificationValue[CommentNotificationValue["MyFeed"] = 1] = "MyFeed";
    CommentNotificationValue[CommentNotificationValue["InvolvedFeed"] = 2] = "InvolvedFeed";
    CommentNotificationValue[CommentNotificationValue["AllComment"] = 3] = "AllComment";
    CommentNotificationValue[CommentNotificationValue["ReplyFeedComment"] = 4] = "ReplyFeedComment";
})(CommentNotificationValue = exports.CommentNotificationValue || (exports.CommentNotificationValue = {}));
var GroupSortType;
(function (GroupSortType) {
    GroupSortType["Default"] = "-1";
    GroupSortType["Latest"] = "0";
    GroupSortType["Earliest"] = "1";
    GroupSortType["LatestUpdate"] = "2";
})(GroupSortType = exports.GroupSortType || (exports.GroupSortType = {}));
var GroupType;
(function (GroupType) {
    GroupType[GroupType["Public"] = 1] = "Public";
    GroupType[GroupType["Private"] = 2] = "Private";
    GroupType[GroupType["Merchant"] = 3] = "Merchant";
})(GroupType = exports.GroupType || (exports.GroupType = {}));
